import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "@vue/runtime-core";
export default {
  name: "Breadcrumb",
  props: {
    breadcrumbData: {
      type: Array,
      default: () => [] //ex [{ name: "home", path: "/home" }];
    }
  },
  setup(props) {
    const leftOffsetPercentage = ref(0);
    const rightOffsetPercentage = ref(0);
    const leftShadowWidth = computed(() => `${leftOffsetPercentage.value * 40}px`);
    const rightShadowWidth = computed(() => `${rightOffsetPercentage.value * 40}px`);
    let dragging = false;
    let startX = 0;
    let viewport;
    let viewportWidth = 0;
    let contentWidth = 0;
    let offset = 0;
    const startDrag = event => {
      dragging = true;
      startX = event.clientX;
      window.addEventListener("mouseup", stopDrag);
    };
    const stopDrag = () => {
      dragging = false;
      window.removeEventListener("mouseup", stopDrag);
    };
    const doDrag = _.throttle(event => {
      if (dragging) {
        viewport.scrollLeft = viewport.scrollLeft - (event.clientX - startX) / 4;
      }
    }, 16);
    const setShadow = () => {
      if (offset > 0) {
        leftOffsetPercentage.value = (viewport.scrollLeft / offset).toFixed(2);
        rightOffsetPercentage.value = 1 - leftOffsetPercentage.value;
      } else {
        leftOffsetPercentage.value = 0;
        rightOffsetPercentage.value = 0;
      }
    };
    const onScoll = e => {
      setShadow();
    };
    const init = () => {
      viewport = document.body.querySelector(".breadcrumb-viewport");
      viewport.scrollLeft = 0;
      nextTick(() => {
        setTimeout(() => {
          viewportWidth = $(viewport).width();
          contentWidth = $(viewport).find(".el-breadcrumb").width();
          offset = contentWidth - viewportWidth;
          setShadow();
        }, 0);
      });
    };
    watch(props, () => {
      init();
    });
    onMounted(() => {
      init();
      viewport.addEventListener("scroll", onScoll, false);
      window.addEventListener("resize", init);
    });
    onUnmounted(() => {
      viewport.addEventListener("scroll", onScoll, false);
      window.removeEventListener("resize", init);
    });
    return {
      leftShadowWidth,
      rightShadowWidth,
      startDrag,
      stopDrag,
      doDrag
    };
  }
};